import React from 'react'

export default function PublicExpenditure() {
  return (
    <div>PublicExpenditure</div>
  )
}
